export default "__VITE_ASSET__257c413c__"